import { A } from '@ember/array';
import { computed } from '@ember/object';
export default function findBy(dependentKey, propertyKey, value = true) {
  return computed(`${dependentKey}.@each.${propertyKey}`, function () {
    const dependentValue = this.get(dependentKey);
    return dependentValue && A(dependentValue).findBy(propertyKey, value);
  });
}